export default {
  polymer: {
    questionnaire: "བརྟག་དཔྱད་དྲི་ཤོག།",
    getInvolvedNow: "འཕྲལ་མར་ཞུགས་པ།"
  },
  components: {
    indefiniteChoiceQuestions: "ངེས་གཏན་མེད་པའི་རྣམ་གྲངས་选择题།",
    editorialComments: "རྩོམ་སྒྲིག་པའི་དཔྱད་གཏམ།",
    voiceRecordingFailed: "སྐད་གདངས་བརྙན་འབེབས་པ་ཕམ་ཁ་ཁྱེད་ལ་མཐོང་ཆེན་དང་ཚོད་ལྟ།",
    release: "ཁྱབ་བསྒྲགས།",
    myScore: "ང་ཐོབ་སྐར།",
    editReply: "",
    ceviceNotSupport: "ིག་སྔར་སྒྲིག་ཆས་མི་བྱེད་པར་རྒྱབ་སྐྱོར་བྱེད་མཚམས་བཞག་ནས།",
    multipleBlankQuestions: "མང་སྟོང་填空འདྲི་གཞི།",
    required: "ངེས་པར་དུ་འབྲི་ཡི།",
    number: "ཞིག། ",
    score: "ཐོབ་སྐར།",
    notYet: "གནས་སྐབས་མེད་པ།",
    noParticipation: "ཞུགས་མེད་པ་འི།",
    youDidnTPass: "ཁྱེད་ཀྱིས་མ་རྒྱུགས་འཕྲོད་ཞུ་ཡང་འབད་བསྐྱར་འབད།",
    deleteSelectedItemTips: "ཁྱེད་ཀྱིས་གཏན་ཁེལ་སུབ་པ་བདམས་པ་ས་ཡི་གན།",
    notRequired: "མིན་པར་འབྲི་ཡི།",
    stopIt: "མཚམས།",
    classHours: "འཛིན་གྲྭ་སློབ་ཁྲིད་དུས་ཡུན།",
    numberOfCourses: "སློབ་ཚན་སྒོ་གྲངས།",
    failedToPlay: "བསྟན་པའི་འགུལ་ཚད་ཕམ་ཁ་ཁྱེད་ལ་མཐོང་ཆེན་དང་ཚོད་ལྟ།",
    cache: "缓存།",
    currentNonWiFi: "མིག་སྔ་འི་ཆེད་མ་ཡིན་པ་WIFIཁོར་ཡུག་ཟིན་མཚམས་བསྟན་པ།",
    notSupportVoiceUpload : "མིག་སྔར་སྒྲིག་ཆས་རྒྱབ་སྐྱོར་ཡར་འཁོརསྐད་གདངས།",
    edit: "རྩོམ་སྒྲིག་པ།",
    unpublished: "མ་ཁྱབ་བསྒྲགས།",
    isOpen: "ཟིན་པ་དང་སློབ་འགོ་ཚུགས་པ།",
    enterYourAnswer: "ཁྱེད་ཀྱི་ཚད་ཁྱེད་ལ་དྲིས་ལན།",
    trainingTime: "གསོ་སྦྱོང་གི་དུས་ཚོད། ",
    adopt: "བརྒྱུད།",
    participated: "དེ་ཞུགས་པ།",
    answerTips: "ཁྱེད་ཀྱི་ཚད་ལན།",
    chapter: "ལེའུ། ",
    recordingShouldNotExceed_60s: "སྒྲ་ཕབ་ལས་བརྒལ་མི་ཆོག་60s།",
    openingTime: "སློབ་འགོ་ཚུགས་པའི་དུས་ཚོད།",
    theFirst: "དོན་ཚན།",
    endOfRecording: "བརྙན་འབེབས་པ་མཇུག་རྫོགས།",
    unknown: "ཤེས་མེད་པ་འི།",
    signInStartTime: "འབྱོར་ཐོ་འགོད་པ་བཏོན་ནས་དུས་ཚོད།",
    see: "གཟིགས་ཞིབ།",
    comeFrom: "ནས་ཡོང་བ་འི།",
    peopleAreLearning: "མཁན་སློབ།",
    testScores: "རྒྱུགས་ཐོབ་སྐར།",
    registrationDeadline: "མིང་ཐོ་འགོད་པ་མཚམས་འཇོག་པའི་དུས་ཚོད།",
    completion: "填空འདྲི་གཞི།",
    notOpen: "མ་སློབ་འགོ་ཚུགས་པ།",
    ginsengAnd: "མི་ཞུགས།",
    notSupportWechatPlay: "དེའི་རྣམ་གཞག་མི་བྱེད་པར་རྒྱབ་སྐྱོར་བྱས་ཐོག་རྣམ་པ་",
    moreThan: "ཡར་འཁོརཔར་རིས་ཡིག་ཆ་ལས་བརྒལ།",
    unlimited: "མི་མང་ཉུང།",
    placeOfResidence: "རྒྱུན་སྡོད་བྱེད་ས།",
    _2GCellularNetwork: "2Gགོར་མིག་ཅན་དྲ་བ།",
    examinationTime: "རྒྱུགས་ལེན་པའི་དུས་ཚོད།",
    noAskedAQuestion: "ཁྱེད་རང་མ་གླེང་མྱོང་བའི་གནད་དོན།",
    declinedAuthorization: "ཁྱོ་ས་དང་ལེན་མ་སྒྲ་ཕབ་དབང་བསྐུར།",
    startUp: "འགོ་ཚུགས།",
    qualificationPaper: "འཕྲོད་པའི་ལག་ཁྱེར།",
    to: "ཟླ།",
    notSupportPlay: "མིག་སྔར་སྒྲིག་ཆས་རྒྱབ་སྐྱོར་སྐད་གདངས་བསྟན་པ།",
    peopleAreNotInvolved: "མི་ཞུགས་མེད་པ་འི།",
    peopleHaveParticipated: "མི་ཞུགས།",
    pleaseSelectAgain: "ཁྱེད་ལ་བསྐྱར་དུ་འདེམས།",
    youCanOnlyChoose: "ཁྱོད་ཆེས་མང་ཙམ་བསལ་འདེམས།",
    asOf: "སྤྱི་ལོ་ནས།",
    correct: "ཡང་དག་པ་འི།",
    noNetworkConnection: "མ་སྦྲེལ་མཐུད་དྲ་བ།",
    failedToUpload: "ཡར་འཁོརཕམ་ཁ་ཁྱེད་ལ་མཐོང་ཆེན་དང་ཚོད་ལྟ།",
    voicePlayFailed: "སྐད་གདངས་དྲིལ་བསྒྲགས་པར་ཕམ་ཁ་ཁྱེད་ལ་མཐོང་ཆེན་དང་ཚོད་ལྟ།",
    wiredNetwork: "སྐུད་ཡོད་དྲ་བ།",
    deviceNotSupportRecording: "མིག་སྔར་སྒྲིག་ཆས་རྒྱབ་སྐྱོར་སྐད་གདངས་བརྙན་འབེབས་པ།",
    uploadError: "ཡར་འཁོརནོར་འཁྲུལ།",
    photos: "པར།",
    pleaseEnterATitle: "ཁྱེད་ཀྱི་ཚད་ཁ་བྱང།",
    releaseLoadMore: "ལྗང་ཁ་ཁ་སྣོནགླང་རྫི་དེ་བས་མང་བ།",
    strip: "དོན་ཚན།",
    details: "ཞིབ་ཆ།",
    reply: "བརྡ་ལན།",
    NotSupportUploadingPictures: "མིག་སྔར་སྒྲིག་ཆས་རྒྱབ་སྐྱོར་ཡར་འཁོརཔར་རིས།",
    talkingTooShort: "སྐད་ཆ་འི་དུས་ཚོད་ཧ་ཅང་ཐུང།",
    pleasePayAttentionToTraffic: "དེང་སྐབས་ནི་གནས་སྤོ་དྲ་བ་མཉམ་འཇོག་བྱོས་རྒྱུག་ཚད།",
    writeAPrivateLetter: "བྲིས་私信།",
    noEvaluation: "གནས་སྐབས་མེད་པའི་གདེང་འཇོག།",
    wiFiNetwork: "WiFiདྲ་བ།",
    pleaseUseAppToDownload: "མི་བྱེད་པར་རྒྱབ་སྐྱོར་བྱ་འི་རིགས་དབྱིབས་ཀྱི་ཡི",
    latestPhotosUploaded: "ཆེས་གསར་བའི་སྟེང་ནས་མར་了འདྲ་པར།",
    openInBrowserད: "ེ་མཚུངས་གཡས་སྟེང་རྭ་ཞུ་འདེམ་པ་浏览器ཁ་ཕྱེ།",
    reExamTimes: "ལྷག་མ་ཟུར་རྒྱུགས་ལེན་པའི་ཐེངས་གྲངས།",
    anotherAnswerTips: "ཁྱེད་ཀྱི་ཚད་གཞན་ལན།",
    candidates: "འོས་མི།",
    _3GCellularNetwork: "3Gགོར་མིག་ཅན་དྲ་བ།",
    startRecording: "ཐོག་མར་སྒྲ་ཕབ།",
    speaker: "འཆད་འཁྲིད་གཙོ་བོ།",
    isOver: "དེ་མཇུག་གྲིལ་བའི་འཛིན་གྲྭ།",
    topic: "ཁ་བྱང། ",
    certificateOfExcellence: "ཕུལ་བྱུང་གི་ལག་ཁྱེར།",
    workingIn: "ལས་གནས་དེ།",
    personNotSubmitted: "མི་མ་ཕུལ་བ།",
    classes: "འཛིན་གྲྭ་འི།",
    error: "ནོར་འཁྲུལ།",
    noSignIn: "མི་མ་འབྱོར་ཐོ་འགོད་པ།",
    duration: "དུས་རིང།",
    downloads: "ཐེངས་ཁ་",
    systemNotice: "སྤྱི་བསྒྲགས།",
    noIntroduction: "གནས་སྐབས་མེད་པའི་ངོ་སྤྲོད།",
    notSignedIn: "མ་འབྱོར་ཐོ་འགོད་པ།",
    _4GCellularNetwork: "4Gགོར་མིག་ཅན་དྲ་བ།",
    on: "དེ།",
    notice: "གསར་འགྱུར།",
    submittedBy: "མི་སྤྲོད་པ།",
    hours: "སློབ་ཁྲིད་དུས་ཡུན།",
    pleaseGoToPc: "ཁྱོ་ས་PCརྒྱལ་བོ་གཟིགས་ཞིབ་བསྡོམས་རྩིས་འབྲས་བུ།",
    notRegistered: "མ་མིང་ཐོ་འགོད་པ།",
    learned: "དེ་སློབ།",
    itIsNotWiFi: "མིག་སྔ་འི་ཆེད་མ་ཡིན་པ་WIFIརྣམ་པ་མིན་མུ་མཐུད།",
    passRate: "通过率།",
    isSubmit: "དེ་ཕུལ་བ།",
    classSize: "འཛིན་གྲྭ་འི་མི་གྲངས།",
    signIn: "འབྱོར་ཐོ་འགོད་པ།",
    personSignIn: "མི་འབྱོར་ཐོ་འགོད་པ།",
    pleaseSelect: "ཁྱེད་ཀྱི་བསལ་འདེམས།",
    comment: "དཔྱད་གཏམ།",
    yourPassing: "བཀྲ་ཤིས་བདེ་ལེགས་ཞུ་བ་ཁྱེད་ངང་རྒྱུགས་འཕྲོད།",
    lineWork: "ཐིག་བྱ་བ་བསྒྲུབ་རྒྱུ།"
  },
  resource: {
    commonResources: "སྤྱི་སྤྱོད་ཐོན་ཁུངས།",
    resources: "ཐོན་ཁུངས།",
    resourceDetails: "ཐོན་ཁུངས་ཞིབ་ཆ།",
    classResources: "འཛིན་གྲྭ་འི་ཐོན་ཁུངས།",
    goToAppOrPcToDownload: "ག་ལེ་ཕེབས་appའམ་pcརྒྱལ་བོ་下载བཀོལ་སྤྱོད།",
    downloadDetails: "下载ཞིབ་ཆ།"
  },
  student: {
    preschool: "སློབ་ཞུགས་གོང་གི།",
    learning: "སློབ་སྦྱོང་ཁྲོད།",
    onlineEvaluation: "ནི་ཐིག་དཔྱད་བསྡུར།"
  },
  classes: {
    data: 'དཔྱད་ཡིག།',
    cancelTheLeaveTips: "ཁྱེད་ཀྱིས་གཏན་ཁེལ་མེད་པར་བཟོས་པ་དང་དུས་ཚོད་དམ།",
    teachingEvaluation: "སློབ་ཁྲིད་གདེང་འཇོག།",
    pleaseEnterTheAnswer: "ཁྱེད་ཀྱི་ཚད་ལ་ལན།",
    opinionBeEmpty: "བསམ་འཆར་ནང་དོན་དེ་སྟོང།",
    registered: "སྔར་ཡོད་ཀྱི་ཐོ་འགོད།",
    classmate: "སློབ་གྲོགས།",
    deletePhotoTips: "ཁྱེད་ཀྱིས་གཏན་ཁེལ་སུབ་པ་དེའི་འདྲ་པར་གན།",
    notInTheClass: "མིག་སྔར་སྤྱོད་མཁན་མི་དེར་འཛིན་གྲྭ།",
    disagreeAndGiveOpinions: "མི་འི་མོས་མཐུན་བྱས་པ་མ་ཟད་གཏོང་རྒྱུ་འི་བསམ་འཆར།",
    sickLeave: "ནད་དགོངས།",
    checkInPeriod: "འབྱོར་ཐོ་འགོད་པ་དུས་རིམ།",
    problemContentEmpTips: "གནད་དོན་གྱི་ནང་དོན་དེ་སྟོང།",
    enclosure: "ཟུར་བཀོད།",
    classCommunication: 'འཛིན་གྲྭ་འི་འཕྲིན་གཏོང།',
    pleaseSelectLeaveType: "ཁྱེད་ཀྱི་བསལ་འདེམས་ཀྱི་དུས་ཚོད་དང་རིགས་དབྱིབས།",
    classCourses: "འཛིན་གྲྭ་འི་སློབ་ཚན།",
    evaluated: "སྔར་ཡོད་ཀྱི་གདེང་འཇོག།",
    enteringTheClass: "འདི་ཉིད་འཛིན་གྲྭ།",
    groupLeader: "ཙུའུ་ཀྲང།",
    classAnnouncement: "འཛིན་གྲྭ་འི་སྤྱི་བསྒྲགས།",
    normalAttendance: "རྒྱུན་ལྡན་གྱི་ལས་ཀར་འབྱོར་བ།",
    urging: "ལས་སྒྲུབ་སྐུལ་འདེད།",
    curriculumEvaluation: "སློབ་ཚན་ལ་གདེང་འཇོག།",
    discussionContentTips: "ཁྱེད་ཀྱི་ཚད་ལ་གྲོས་བསྡུར་བྱེད་པའི་ནང་དོན།",
    completed: "ལེགས་གྲུབ་ཟིན་པ།",
    agree: "མོས་མཐུན།",
    signUpNow: "འཕྲལ་མར་མིང་ཐོ་འགོད་པ།",
    leaveEarly: "སྔ་ལོག།",
    loading: "加载中།",
    noClassToday: "དེ་རིང་མ་སློབ་ཚན་ལྷོད་ཅིག།",
    unknownError: "ཤེས་མེད་པའི་ནོར་འཁྲུལ།",
    theInvestigationTerminated: "དེར་བརྟག་དཔྱད་ཟིན་པ་མཚམས་འཇོག།",
    youDidNotParticipateIn: "ཁྱེད་ལ་མ་ཞུགས་པའི་དཔྱད་དཔོག།",
    noPersonnel: "གནས་སྐབས་མེད་པའི་མི་སྣ།",
    selectUploadPhoto: "ཁྱེད་ཀྱི་བསལ་འདེམས་དགོས་པ་ཡར་འཁོརའདྲ་པར།",
    endSignIn: "མཇུག་བསྒྲིལ་འབྱོར་ཐོ་འགོད་པ།",
    evaluationEmptyTips: "གདེང་འཇོག་བྱེད་པའི་ནང་དོན་དེ་སྟོང།",
    notSigned: "མ་འཛར།",
    failedToUrge: "ལས་སྒྲུབ་སྐུལ་འདེད་ཕམ་ཁ།",
    classScheduleCard: "课程表།",
    putQuestions: "དྲི་བ།",
    submitting: "བཞིན་ལ་ཕུལ་བ།",
    allStates: "ཚང་མའི་རྣམ་པ།",
    everyoneSignedIn: "བདག་པོ་ཚང་མ་ཟིན་པ་འབྱོར་ཐོ་འགོད་པ།",
    giveAFalseOpinion: "ལ་རྫུན་མ་བསམ་འཆར།",
    talking: "སྐད་ཆ་འི་ཁྲོད།。。",
    matter: "བྱ་བ།",
    signInStartTime: "འབྱོར་ཐོ་འགོད་པ་བཏོན་ནས་དུས་ཚོད།",
    classDetails: "འཛིན་གྲྭ་འི་ཞིབ་ཆ།",
    enterYourComment: "ཁྱེད་ཀྱི་ཚད་ཁྱེད་ཀྱི་དཔྱད་གཏམ།",
    search: "བཤེར་འཚོལ།",
    noNotes: "གནས་སྐབས་མེད་པའི་ཟིན་ཐོ།",
    announcementDetails: "སྤྱི་བསྒྲགས་ཞིབ་ཆ།",
    leaveReview: "དགོངས་ཞུ་ཞིབ་བཤེར།",
    letSGoPlayForAWhile: "སྔོན་ལ་རྩེད་མོ་ཞིག་ཡོང་རྒྱུ་ར།",
    allSubmitted: "ཡོད་ཚད་ཚང་མ་ཟིན་པ་འབུལ་ལས་བྱ།",
    topping: "གཅོད་ཀྱི་མདུན།",
    youHaveOrNotStarted: "ཁྱེད་ནི་འབྱོར་ཐོ་འགོད་པ་དང་།ཡང་ན་འབྱོར་ཐོ་འགོད་པ་མ་བཟུང",
    communicationEmpty: "སྤེལ་རེས་བྱེད་པའི་ནང་དོན་དེ་སྟོང།",
    noClassInTheEvening: "དགོང་མོ་མ་སློབ་ཚན་ལྷོད་ཅིག།",
    illness: "ནད།",
    gettingTimedOut: "ཆ་འཕྲིན་ལག་སོན་超时།",
    dataDownload: "དཔྱད་ཡིག་ཁ་",
    auditFailed: "ཞིབ་བཤེར་གཏན་འབེབས་མ་བྱས་པར་བརྟེན་ནས།",
    classLocation: "འཛིན་གྲྭ་འི་གནས་ཡུལ།",
    photo: "འདྲ་པར།",
    checkInNotStarted: "འབྱོར་ཐོ་འགོད་པ་མ་བཟུང།",
    theInvestigationLaunched: "དེར་བརྟག་དཔྱད་ཟིན་པའི་འགོ་ཚུགས།",
    holdToTalk: "按住སྐད་ཆ།",
    selectStartTimeOfLeave: "ཁྱེད་ཀྱི་བསལ་འདེམས་ཀྱི་དུས་ཚོད་འགོ་ཚུགས་པའི་དུས་ཚོད།",
    opinion: "བསམ་འཆར།",
    call: "ཁྲོས་པ་འི།",
    notEvaluated: "མ་གདེང་འཇོག།",
    newReply: "དོན་ཚན་གསར་པར་བརྡ་ལན།",
    classLecturer: "འཛིན་གྲྭ་འི་འཆད་འཁྲིད་དགེ་རྒན།",
    teacherAnswersQuestions: "དགེ་རྒན་གྱིས་ལན་འདེབས་པ།",
    classPhotoAlbum: "འཛིན་གྲྭ་འདྲ་པར་ཉར་དེབ།",
    pleaseWait: "ཁྱོ་ས་མི་རིང་བ་ར།",
    notGetLocation: "གནས་སྐབས་ལག་སོན་མི་གནས་ཆ་འཕྲིན།",
    ask: "འདྲི།",
    openEnrollment: "སྒོ་འབྱེད་མིང་ཐོ་འགོད་པ།",
    searchHistory: "བཤེར་འཚོལ་ལོ་རྒྱུས།",
    uploadPhotos: "ཡར་འཁོརའདྲ་པར།",
    operationDetails: "ལས་སྒྲུབ་གནས་ཚུལ་ཞིབ་ཕྲ།",
    discuss: "གྲོས་བསྡུར།",
    noContent: "གནས་སྐབས་མེད་པའི་ནང་དོན།",
    dropDownToRefresh: "འོག་འཐེན་ཐུབ་པའི་གསར་གཏོད་སློབ་མ་འབྱོར་ཐོ་འགོད་པའི་གནས་",
    registrationStatus: "མིང་ཐོ་འགོད་པའི་རྣམ་པ།",
    communicationDetails: "འཕྲིན་གཏོང་ཞིབ་ཆ།",
    noBriefIntroduction: "གནས་སྐབས་མེད་མཚམས་སྦྱོར་མདོར་བསྡུས།",
    uploadMax9: "གཅིག་ཐེངས་ཆེས་མང་བ་ཡར་འཁོར9པར།",
    noClassThisMorning: "དེ་རིང་སྔ་དྲོ་མ་སློབ་ཚན་ལྷོད་ཅིག།",
    empty: "清空།",
    pleaseUseAppOrPc: "ཁྱོ་ས་appའམ་pcརྒྱལ་བོ་བཀོལ་སྤྱོད་བྱ་ནུས་པ།",
    successfulUrging: "ལས་སྒྲུབ་སྐུལ་འདེད་ལེགས་གྲུབ།",
    late: "ཡོང་འཕྱི་བ་འི།",
    downloading: "下载ཁྲོད།",
    leave: "དགོངས་ཞུ།",
    auditPassed: "ཞིབ་བཤེར་དེ།",
    uploading: "ཡར་འཁོརཁྲོད་...།",
    reply: "བརྡ་ལན།",
    signOutPeriod: "འཛར་ཞིང་དུས་རིམ།",
    communication: "སྤེལ་རེས།",
    temporarySignIn: "གནས་སྐབས་འབྱོར་ཐོ་འགོད་པ།",
    suspend: "མཚམས་འཇོག་རྒྱུའི།",
    publishSuccessfully: "ཁྱབ་བསྒྲགས་བྱས་ནས་ལེགས་འགྲུབ་བྱུང་བ།",
    iGotIt: "ང་ས།",
    reasonsForRejection: "སུན་འབྱིན་རྒྱུ་རྐྱེན།",
    pleaseEnterTheQuestion: "ཁྱེད་ཀྱི་ཚད་གནད་དོན།",
    discussionContentEmpTips: "གླེང་མོལ་གྱི་ནང་དོན་དེ་སྟོང།",
    mailList: "通讯录།",
    finished: "དེ་མཇུག་འགྲིལ།",
    classStatus: "འཛིན་གྲྭ་འི་རྣམ་པ།",
    noClassThisAfternoon: "དེ་རིང་ཕྱི་དྲོ་མ་སློབ་ཚན་ལྷོད་ཅིག།",
    registrationIsFull: "མིང་ཐོ་འགོད་པ་རང་ལོ།",
    underReview: "ཞིབ་བཤེར་ཁྲོད།",
    toBeAnswered: "དེ་རྗེས་བརྡ་ལན།",
    attendanceDetails: "མིན་རྟོག་ཞིབ་ཞིབ་ཆ།",
    lateLeaveEarly: "ཡོང་འཕྱི་བ་/སྔ་ལོག།",
    personSubmitted: "མི་དེ་ཕུལ་བ།",
    selectEndTimeOfLeave: "ཁྱེད་ཀྱི་བསལ་འདེམས་ཀྱི་དུས་ཚོད་མཇུག་སྒྲིལ་བའི་དུས་ཚོད།",
    sendSms: "སྐྱེལ་བ་འཕྲིན་ཐུང།",
    compassionateLeave: "དགོངས་ཞུ།",
    task: "ལས་བྱ།",
    endOfRegistration: "མིང་ཐོ་འགོད་པ་མཇུག་རྫོགས།",
    inTheDevelopment: "གསར་སྤེལ་ཁྲོད་རང་ཉིད་ཀྱི་རེ་སྒུག་...།",
    uploadSuccessful: "ཡར་འཁོརལེགས་གྲུབ།",
    uploadFailed: "ཡར་འཁོརཕམ་ཁ།",
    applicationDate: "རེ་ཞུ་འི་ཚེས་གྲངས།",
    questionnaire: "དྲི་ཤོག།",
    personNotSubmitted: "མི་མ་ཕུལ་བ།",
    submit: "འབུལ།",
    waiting: "རེ་སྒུག་ཁྲོད།",
    classWork: "འཛིན་གྲྭ་འི་ལས་བྱ།",
    rejected: "དེ་སུན་འབྱིན།",
    replied: "ཟིན་པར་བརྡ་ལན།",
    classSurvey: "འཛིན་གྲྭ་འི་བརྟག་དཔྱད།",
    absence: "མི་ལས་ཆད།",
    inputTheReasonForLeave: "ཁྱེད་ཀྱི་ཚད་དགོངས་ཞུ་འི་རྒྱུ་རྐྱེན།",
    certificate: "ལག་ཁྱེར།",
    finishTips: "ཁྱེད་ཀྱིས་གཏན་ཁེལ་བྱེད་པ་མཇུག་བསྒྲིལ་གན།",
    addedSuccessfully: "གསར་དུ་ལེགས་འགྲུབ་བྱུང་བ།",
    noSignIn: "གནས་སྐབས་མེད་པ་འབྱོར་ཐོ་འགོད་པ།",
    inputLeaveOpinion: "ཁྱེད་ཀྱི་ཚད་ལ་རྫུན་མ་བསམ་འཆར།",
    teacher: "དགེ་རྒན།",
    toBeReviewed: "མྱུར་དུ་ཞིབ་བཤེར།",
    examination: "རྒྱུགས་ལེན།",
    classIntroduction: "འཛིན་གྲྭ་འི་ངོ་སྤྲོད་མདོར་བསྡུས།",
    messageArea: "མཐོང་སྣང་འབྲི་བ་ཁུལ།",
    studentsNotSignedIn: "མ་འབྱོར་ཐོ་འགོད་པའི་སློབ་མ།",
    class: "འཛིན་གྲྭ་འི།",
    locationServiceDenied: "སྡོད་གནས་ཞབས་ཞུ་བྱ་ཡུལ་གྱི་མི།",
    voiceCannotBeEmpty: "སྐད་སྒྲ་དེ་སྟོང།",
    downloadNow: "འཕྲལ་མར་ཁ་",
    uploadLeaveTips: "ཁྱེད་ཀྱིས་ད་དུང་པར་རིས་མ་ཡར་འཁོརནས་བྲལ་ར",
    classAssessment: "འཛིན་གྲྭ་འི་དཔྱད་དཔོག།",
    headmaster: "འཛིན་གྲྭ་འི།",
    youHave: "ཁྱེད།",
    allParticipantsSubmitted: "སློབ་མ་ཚང་མར་ཕུལ་བ།",
    abnormalData: "གཞི་གྲངས་ཐུན་མོང་མ་ཡིན་པ།",
    newLeave: "གསར་སྣོན་བྱས་པའི་དུས་ཚོད།",
    AssessmentIsNotOver: "དཔྱད་དཔོག་གནས་སྐབས་སུ་མཇུག་རྫོགས།",
    aboutToSignUp: "མི་འགྱངས་པར་མིང་ཐོ་འགོད་པ།",
    notSupportUploading: "མིག་སྔར་སྒྲིག་ཆས་རྒྱབ་སྐྱོར་ཡར་འཁོརཔར་རིས།",
    youHaveThisSurvey: "ཁྱོད་ཉིད་ཞུགས་མྱོང་བ་དང་ད་ཐེངས་ཀྱི་བརྟག་དཔྱད།",
    leaveDate: "དགོངས་ཞུ་འི་ཚེས་གྲངས།",
    writeComments: "འབྲི་འི་དཔྱད་གཏམ།",
    noProblemAtTheMoment: "གནས་སྐབས་མེད་པའི་གནད་དོན།",
    attendance: "མིན་རྟོག་ཞིབ་གནས་ཚུལ།",
    initiateDiscussion: "གྲོས་འགོ་བཏོན་ནས་གྲོས་བསྡུར།",
	noResour:"暂无资料",
	addNotes:"添加笔记"
  },
  bag: {
    faceToFaceClass: "གདོང་འཕྲདའཛིན་གྲྭ།",
    notStarted: "མ་བཟུང།",
    finished: "དེ་མཇུག་འགྲིལ།",
    electiveCourse: "སྦྱོང་བསླབ་ཚན།",
    failed: "མ་བརྒྱུད།",
    passingState: "བརྒྱུད་དེ་རྣམ་པ།",
    examinationStatus: "རྒྱུགས་ལེན་རྣམ་པ།",
    onlineSpecialClass: "དྲ་ཐོག་ཆེད་དོན་འཛིན་གྲྭ།",
    requiredCourse: "必修课།",
    noExamination: "མ་རྒྱུགས་ལེན།",
    marking: "རྒྱུགས་དཔྱད་ཀྱི་ཁྲོད།",
    myStudy: "ང་འི་སློབ་སྦྱོང།",
    iAmLearning: "སློབ་སྦྱོང་བྱེད་པའི་ཁྲོད།",
    examineeStatus: "རྒྱུགས་སྤྲོད་སློབ་མའི་རྣམ་པ།",
    cancelled: "དེ་མེད་པར་བཟོ།",
    haveInHand: "ལ་ནང།",
    passed: "དེ།",
    faceToFaceTrainingCourse: "གདོང་འཕྲདགསོ་སྦྱོང་འཛིན་གྲྭ།",
    noticeNotice: "བརྡ་ཐོ་ཁྱབ་བསྒྲགས།",
    onlineClass: "དེ་ན་འཛིན་གྲྭ།"
  },
  login: {
    loginNetworkErr: "登录ཐུན་མོང་མ་ཡིན་པ་ཞུ་ལྕི་བའི་ཚོད་ལྟ།",
    passwordEmp: "གསང་བ་དེ་སྟོང།",
    inputUserName: "ཁྱེད་ཀྱི་ཚད་སྤྱོད་མཁན་མིང་།",
    loginErr2: "登录ཐུན་མོང་མ་ཡིན་པ་ཞུ་ལྕི་བའི་ཚོད་ལྟ།",
    loginErr1: "登录ཐུན་མོང་མ་ཡིན་པ་གྲབས་ཡ་ཐོག་གསོལ་ལན་འབུལ་བ་ལྕི་ཚོད་ལྟ་བྱེད་པ།",
    toHome: "སྣེ་འཁྲིད་ཤོག་ལྷེ་དང་པོ།",
    bind: "མགོ་སྦྲེལ།",
    bindSuccessOk: "རྩིས་ཐོའི་ཨང་གྲངས་མགོ་སྦྲེལལེགས་གྲུབ།",
    inputPasword: "ཁྱེད་ཀྱི་ཚད་ཨང་ཡིག།",
    userNameEmp: "སྤྱོད་མཁན་མིང་དེ་སྟོང།",
    resetPwdSuccess: "ཨང་ཡིག་ལྕི་གཅོད་ལེགས་གྲུབ།",
    loginPage: "登录ཤོག་ངོས།",
	inputCode:"请输入验证码",
    codeErr: "ཚོད་ལྟ་ས་ར་སྤྲོད་དང་བར་ནོར་འཁྲུལ།",
    sendSuccess: "སྐྱེལ་བ་ལེགས་གྲུབ།",
    bindOtherTips: "ཁྱེད་ནི་མགོ་སྦྲེལ了གཞན་དག་ཐོག་རྣམ་རྩིས་ཐོའི་ཨང་གྲངས།གལ་ཏེ་བརྗེ་ཐོག་རྣམ་སྔོན་ལ་སེལ་བཀྱིགས་ཐོག་རྣམ་རྩིས་ཐོའི་ཨང་གྲངས།",
    bindExistingAccount: "ཁྱེད་ཀྱི་མགོ་སྦྲེལསྔར་ཡོད་རྩིས་ཐོའི་ཨང་གྲངས།",
    userErr: "རྩིས་ཐོའི་ཨང་གྲངས་འམ་གསང་བའི་ནོར་འཁྲུལ།",
    loginConflictTips: "དེའི་རྩིས་ཐོའི་ཨང་གྲངས་ཟིན་པ་དང་གཞན་གྱི་སྒྲིག་ཆས་登录།",
    reSend: "བསྐྱར་དུ་སྐྱེལ་བ།",
    bindSuccessTips: "ཁྱེད་ནི་མགོ་སྦྲེལརྩིས་ཐོའི་ཨང་གྲངས་ལེགས་གྲུབ་སྤྱད་ཆོག་ཐོག་རྣམ་登录།",
    learningFlowSuccess: "སློབ་སྦྱོང་འབབ་ཆུ་འབུལ་ལེགས་གྲུབ།",
    messageErr: "འཕྲིན་ཐུང་ཚོད་ལྟ་ས་ར་སྤྲོད་མ་ཚད་མི་ཡང་དག་པ།",
    alreadyBind: "ཁྱེད་ནི་མགོ་སྦྲེལའཕྲིན་ཐུང་གི་རྩིས་ཐོའི་ཨང་གྲངས།",
    verificationCont: "ཚོད་ལྟ་ས་ར་སྤྲོད་མ།",
    bindResult: "མགོ་སྦྲེལའབྲས་བུ་ཤོག་ངོས།",
    resetPwdFail: "ཨང་ཡིག་ལྕི་གཅོད་ཀྱི་ཕམ་ཁ།",
    bindSuccess: "མགོ་སྦྲེལལེགས་གྲུབ།",
    loginText: "登录།",
    messageEmp: "འཕྲིན་ཐུང་ཚོད་ལྟ་ས་ར་སྤྲོད་མ་དེ་སྟོང།",
    codeEmp: "ཚོད་ལྟ་ས་ར་སྤྲོད་མ་དེ་སྟོང།",
    register: "ཐོ་འགོད།"
  },
  evaluateStart: {
    newAnswerArea: "གསར་སྣོན་བྱས་པའི་དྲིས་ལན་ཁ་བྱང་ས་ཁོངས།",
    itSTheLastQuestion: "ཟིན་པ་མཇུག་མཐར་གནད་དོན་了།",
    shortAnswerQuestions: "简答题།",
    classAssessment: "འཛིན་གྲྭ་འི་དཔྱད་དཔོག།",
    multipleChoiceQuestions: "མང་དཔྱད་གཞི།",
    listOfTopics: "ཁ་བྱང་རེའུ་མིག་བཀོད།",
    handInThePaperTips: "ཁྱེད་ཀྱིས་གཏན་འཁེལ་རྒྱུགས་ཡིག་སྤྲོད་པ་དང་གན།",
    evaluationQuestions: "གདེང་འཇོག་འདྲི་གཞི།",
    tableTitle: "རེའུ་མིག་འབྲི།"
  },
  setting: {
    aboutUs: "སྐོར་ལ་ང་ཚོ།",
    resetPassword: "བསྐྱར་གཅོད་ཀྱི་གསང་བ།",
    phoneEmp: "ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས་དེ་སྟོང།",
    passwordNotUniform: "གསར་པ་གསང་བ་མི་གཅིག་གྱུར།",
    bindPhone: "མགོ་སྦྲེལལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས།",
    inputFeedback: "ཁྱེད་ཀྱི་ཚད་བསམ་འཆར།",
    allowNonWiFiDownload: "གཏན་ནས་མིན་པ་WIFIདྲ་རྒྱ་ཁ་",
    resendSms: "བསྐྱར་དུ་སྐྱེལ་བ་འཕྲིན་ཐུང་ཚོད་ལྟ་ས་ར་སྤྲོད་མ།",
    feedback: "བསམ་འཆར།",
    helpCenter: "རོགས་རམ་ལྟེ་གནས།",
    originalPassword: "ཐོག་མའི་གསང་བ།",
    skinSwitch: "སྐྱི་པགས་切换།",
    bindingSucceeded: "ལག་ཐོགས་ཁ་པར་མགོ་སྦྲེལལེགས་གྲུབ།",
    mobileAlreadyExists: "ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས་གནས་པ་ར།",
    agreementService: "《དགེ་བ་སློབ་ཞབས་ཞུ་བཀོལ་སྤྱོད་བྱེད་པའི་གྲོས་མཐུན་》།",
    warning: "པར་གཞི་ལ་违者必究།",
    confirmPassword: "ངོས་འཛིན་ཨང་ཡིག།",
    setUp: "བཀོད་སྒྲིག།",
    mobileNetworkDownload: "སྤོ་སྒུལ་དྲ་རྒྱ་下载སྲིད་སློང་ཚད་བརྒལ་རྒྱུག་ཚད་",
    sendSmsCodeTo: "ང་ཚོ་ར་སྐྱེལ་བ་འཕྲིན་ཐུང་ཚོད་ལྟ་ས་ར་སྤྲོད་མ་བྱས་ནས།",
    passwordleng: "གསང་བ་དེ་8-16ཞིག་ཡིག་རྟགས་གྲུབ་པ།",
    email: "Email",
    boundByAnotherAccount: "དེའི་ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས་ཟིན་པ་གཞན་དག་རྩིས་ཐོའི་ཨ",
    inputCode: "ཁྱེད་ཀྱི་ཚད་ཚོད་ལྟ་ས་ར་སྤྲོད་མ།",
    mobileNetworkPlay: "སྒུལ་བདེ་འི་དྲ་རྒྱ་འི་བསྟན་པ་སྲིད་པ་སློང་ཚད་བ",
    allowNonWiFiPlay: "གཏན་ནས་མིན་པ་WIFIདྲ་རྒྱ་བསྟན་པ།",
    serviceTelephone: "客服ཁ་པར།",
    newPassword: "གསར་པ་ཨང་ཡིག།",
    newPasswordemp: "གསར་པ་གསང་བ་དེ་སྟོང།",
    pleaseInput_11PhoneNumber: "ཁྱེད་ཀྱི་ཚད་བཅུ་གཅིག་སྐམ་ས་ཆེན་པོ་འི་ལག་ཐོགས་ཁ་པར་གྱི་ཨང",
    downloaded: "དེ་ཁ་",
    phoneFormatError: "ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས་རྣམ་གཞག་ནོར་འཁྲུལ།",
    sendSms: "སྐྱེལ་བ་འཕྲིན་ཐུང་ཚོད་ལྟ་ས་ར་སྤྲོད་མ།",
    serviceAgreement: "ཞབས་ཞུ་འི་དོན་ཚན་བེད་སྤྱོད་བྱ་རྒྱུ་འི་གྲོས་མཐུན།",
    originalPasswordEmp: "ཐོག་མའི་གསང་བ་དེ་སྟོང།",
    smsVerification: "འཕྲིན་ཐུང་ཚོད་ལྟ་ས་ར་སྤྲོད།",
    codeError: "འཕྲིན་ཐུང་ཚོད་ལྟ་ས་ར་སྤྲོད་དང་བར་ནོར་འཁྲུལ།",
    nextStep: "གོམ་སྟབས་རྗེས་མ་འི།",
    passwordResetFailed: "བསྐྱར་གཅོད་ཀྱི་གསང་བའི་ཕམ་ཁ།",
    passwordResetSucceeded: "བསྐྱར་གཅོད་ཨང་ཡིག་ལེགས་གྲུབ།",
    originalPasswordError: "ཐོག་མའི་གསང་བའི་ནོར་འཁྲུལ།",
    logOut: "ཕྱིར་འཐེན་登录།"
  },
  exam: {
    examinationResults: "རྒྱུགས་ལེན་གྱི་མཇུག་འབྲས།",
    reExamination: "བསྐྱར་དུ་རྒྱུགས་ལེན།",
    inMarking: "རྒྱུགས་དཔྱད་ཀྱི་ཁྲོད་དུ་...།",
    passedTheExam: "ཁྱེད་ཀྱི་རྒྱུགས་ལེན་དེ།",
    examinationRecord: "རྒྱུགས་ལེན་ཟིན་ཐོ།",
    highScoreRanking: "སྐར་གྲངས་མཐོན་པོ་排行榜།",
    highestScore: "ཆེས་མཐོའི་ཐོབ་སྐར།",
    historicalRecords: "ལོ་རྒྱུས་ཀྱི་ཟིན་ཐོ།",
    examinationIsOver: "རྒྱུགས་ལེན་དེ་མཇུག་འགྲིལ།",
    knowledgeContest: "ཤེས་བྱ་འི་འགྲན་བསྡུར།",
    examinationDuration: "རྒྱུགས་ལེན་དུས་རིང་པོ།",
    signUpForTheExam: "ཐོ་འགོད་ཡིག་རྒྱུགས།",
    latestScore: "ཆེས་གསར་བ་ཐོབ་སྐར།",
    notAllowedSeeResolution: "ད་རེས་ཡིག་ཚད་མི་ཆོག་པར་ཕེབས་ནས་དབྱེ་ཞིབ།",
    analysisOfQuestions: "རྒྱུགས་གཞི་དབྱེ་ཞིབ།",
    reExaminationTimes: "ལྷག་མ་ཟུར་རྒྱུགས་ལེན་པའི་ཐེངས་གྲངས།",
    noPassedAllowedSeeResolution: "ཁྱེད་ལ་རྒྱུགས་མ་བརྒྱུད་ན་མི་ཆོག་པར་ཕེབས་ནས་དབྱེ་ཞིབ།",
    examIsMax: "ཟིན་པའི་རྒྱུགས་ལེན་ཐེངས་གྲངས་ནོར་སྲིད་སྲིད་ཇུས།",
    noAnalysis: "གནས་སྐབས་མེད་པའི་དབྱེ་ཞིབ།",
    startTheExam: "ཐོག་མར་རྒྱུགས་ལེན།",
    pleaseSelectOrEnterTheAnswer: "ཁྱེད་ཀྱི་བསལ་འདེམས་ཡང་ན་ཚད་ལན།",
    handInPaperTime: "རྒྱུགས་ཡིག་སྤྲོད་པའི་དུས་ཚོད་ནི།མ་ལག་ཁྱེད་ལ་རང་འག",
    SpecificTimeNotice: "ཞིབ་ཕྲ་འི་དུས་ཚོད་རོགས་སྒུག་པའི་མ་ལག་གི་བརྡ་ཐོ།"
  },
  teacher: {
    otherMatters: "གཞན་གྱི་དོན་དག།",
    newTeachers: "གསར་སྣོན་བྱས་པའི་དགེ་རྒན།",
    workUnit: "ལས་གནས་སྡེ་ཚན།",
    teachingExpertise: "སློབ་ཁྲིད་ཀྱི་ཡོན་ཏན།",
    positionTitle: "གོ་གནས་/ཐོབ་ཐང།",
    recommendTeachers: "འོས་སྦྱོར་དགེ་རྒན།",
    teacherName: "དགེ་རྒན་གྱི་མིང།",
    placeOfResidence: "རྒྱུན་སྡོད་བྱེད་ས།",
    notSubmitted: "མ་ཕུལ་བ།",
    newlyAdded: "གསར་སྣོན།",
    instructorDetails: "འཆད་འཁྲིད་དགེ་རྒན་ཞིབ་ཆ།",
    teachingLevel: "མཐུན་པའི་སློབ་ཁྲིད་བྱ་ཡུལ་གྱི་རིམ་པ།",
    aboutInstructor: "འཆད་འཁྲིད་དགེ་རྒན་ངོ་སྤྲོད།",
    chargingStandard: "རིན་བསྡུ་འི་ཚད་གཞི།",
    suitableBusinessLine: "མཐུན་པའི་ལས་སྒོ་འི་ཐིག།",
    modify: "བཟོ་བཅོས།",
    contactInformation: "འབྲེལ་གཏུག་བྱེད་སྟངས།",
    teacherProfile: "དགེ་རྒན་གྱི་ངོ་སྤྲོད་མདོར་བསྡུས།",
    pleaseConfirmComplete: "ཁྱེད་ཀྱི་ངོས་འཛིན་འབྲི་ཆ་ཚང།",
    lectureStyle: "སློབ་ཁྲིད་ཀྱི་ཉམས་འགྱུར།",
    thisItemIsRequired: "ཐེངས་འདི་ར་འབྲི།",
    allTeachers: "དགེ་རྒན་ཡོངས་ཀྱི།",
    recommendedUnit: "འོས་སྦྱོར་སྡེ་ཚན།",
    lecturerSResume: "འཆད་འཁྲིད་དགེ་རྒན་ལོ་རྒྱུས།"
  },
  common: {
    more: 'དེ་བས་མང་བ།',
    operationFailed: "བཀོལ་སྤྱོད་ཕམ་ཁ།",
    pleaseScan: "二维码།",
    cancel: "མེད་པར་བཟོ་བ།",
    noMoreData: "མེད་ལ་དེ་བས་མང་བའི་གཞི་གྲངས་了།",
    signInSuccessfully: "འབྱོར་ཐོ་འགོད་པ་ལེགས་གྲུབ།",
    HistoryFlowSednError: "ལོ་རྒྱུས་ཀྱི་གཞུང་ལ་ཕུལ་བའི་ཕམ་ཁ།",
    whole: "ཚང་མ།",
    homePage: "ཤོག་ལྷེ་དང་པོ།",
    deletionSucceeded: "སུབ་པ་ལེགས་གྲུབ།",
    singleAnswer: "གཅིག་པུ་ར་དཔྱད་གཞི།",
    modificationFailedPleaseTryAgain: "བཟོ་བཅོས་ཕམ་ཁ་ཁྱེད་ལ་མཐོང་ཆེན་དང་ཚོད་ལྟ།",
    multipleAnswer: "མང་དཔྱད་གཞི།",
    evaluated: "སྔར་ཡོད་ཀྱི་གདེང་འཇོག།",
    tryRefreshingAndTryAgain: "སླར་ཚོད་ལྟ་གསར་བཅོས་རྗེས་ཡང་བསྐྱར་ཚོད་ལྟ།",
    examPaperType: "རྒྱུགས་ཤོག་གི་འདྲི་གཞི་ཅན།",
    saveFailed: "ཉར་འཛིན་ཕམ་ཁ།",
    choiceAnswer: "བསལ་འདེམས་填空འདྲི་གཞི།",
    deselectAll: "མེད་པར་ཡོངས་འདེམས།",
    sendOut: "སྐྱེལ་བ།",
    theSignInHasEnded: "དེའི་འབྱོར་ཐོ་འགོད་པ་དེ་མཇུག་འགྲིལ།",
    edit: "རྩོམ་སྒྲིག་པ།",
    nothing: "མེད་པ།",
    night: "དགོང་མོ།",
    loading: "加载中...།",
    gettingLocation: "བཞིན་ལག་སོན་ས་བབ་གནས་ཡུལ་..།",
    submitSuccess: "འབུལ་ལེགས་གྲུབ།",
    doNotOperateFrequently: "སྣབས་རྟུག་ཡང་ཡང་བཀོལ་སྤྱོད།",
    morning: "སྔ་དྲོ་འི།",
    selectAll: "ཡོངས་འདེམས།",
    evaluate: "གདེང་འཇོག།",
    chapter: "ལེའུ།",
    trueAnswer: "བརྡར་ཤ་གཅོད་པའི་ཁ་བྱང།",
    other: "གཞན་དག།",
    reasonsForFailure: "ཕམ་ཁ་བྱུང་བའི་རྒྱུ་མཚན།",
    toEvaluate: "འགྲོ་ལ་གདེང་འཇོག།",
    submitFailed: "ཕུལ་བའི་ཕམ་ཁ།",
    scan: "ཚང་འཇལ་སྤྲོད་གཅིག་ཚང་འཇལ་སྤྲོད།",
    addedSuccessfully: "སྦྱོར་རྟ་ལེགས་གྲུབ།",
    video: "བརྙན་འཕྲིན།",
    courseDownload: "སློབ་ཚན་ཁ་",
    delete: "སུབ་པ།",
    HistoryFlowSendSuccess: "ལོ་རྒྱུས་ཀྱི་འབབ་ཆུ་འབུལ་ལེགས་འགྲུབ་བྱུང་བ།",
    inputContent: "ཁྱེད་ཀྱི་ནང་འདྲེན་བྱེད་པའི་ནང་དོན།",
    pullUpToLoadMore: "ཐོག་拉加载དེ་བས་མང་བ།",
    deletionFailed: "སུབ་པ་ཕམ་ཁ།",
    signOutFailed: "འཛར་ཞིང་ཕམ་ཁ།",
    preservation: "ཉར་འཛིན།",
    file: "文档།",
    common: "ཁྱོན།",
    deletionFailedPleaseTryAgain: "སུབ་པ་ཕམ་ཁ་ཁྱེད་ལ་མཐོང་ཆེན་དང་ཚོད་ལྟ།",
    checkInFailed: "འབྱོར་ཐོ་འགོད་པའི་ཕམ་ཁ།",
    shortAnswer: "简答题།",
    noNet: "འདྲ་མེད་དྲ་བ་了།",
    checkAll: "གཟིགས་ཞིབ་ཡོངས་རྫོགས།",
    determine: "གཏན་ཁེལ།",
    pleaseGiveAScore: "ཁྱེད་ཀྱི་打分།",
    i: "ང།",
    collectionSuccessful: "བསྡུ་ཉར་ལེགས་གྲུབ།",
    multiplePictures: "མང་བའི་པར་རིས།",
    putUp: "收起།",
    examNumber: "རྒྱུགས་ལེན་ཐེངས་གྲངས།",
    people: "མི།",
    signOutSucceeded: "འཛར་ཞིང་ལེགས་གྲུབ།",
    picture: "པར་རིས།",
    noDataText: "གནས་སྐབས་མེད་པའི་གཞི་གྲངས།",
    minute: "སྐར་མ།",
    addFailed: "སྦྱོར་རྟ་ཕམ་ཁ།",
    afternoon: "ཕྱི་དྲོ།",
    newReply: "གསར་པར་བརྡ་ལན།",
    hotSearch: "ཡིད་སྨོན་ས་བཤེར་འཚོལ།",
    submittedSuccessfully: "འབུལ་ལེགས་གྲུབ།",
    signedIn: "དེ་འབྱོར་ཐོ་འགོད་པ།",
    savedSuccessfully: "ཉར་འཛིན་ལེགས་གྲུབ།",
    HistoryFlowSend: "ལོ་རྒྱུས་ཀྱི་འབབ་ཆུ་འབུལ།",
    searchHistory: "བཤེར་འཚོལ་ལོ་རྒྱུས།",
    savePicture: "ཉར་ཚགས་བྱས་པའི་པར་རིས།",
    examTime: "རྒྱུགས་ལེན་དུས་རིང་པོ།",
    loading2: "དུ་བཀྲོད་པའི་ནང།",
    open: "སྤེལ།",
    modificationSucceeded: "བཟོ་བཅོས་ལེགས་གྲུབ།"
  },
  msExamplan: {
    wrongTopic: "ནོར་བ་འབྲི།",
    practice: "གཤར་སྦྱང།",
    successfulRegistration: "",
    clickToSubmitPaper: "དེ་མཚུངས་རྒྱུགས་ཡིག་སྤྲོད་པ་གཅུས་སྒོ་སླར་ཕུལ་རྒྱུགས་ཤོག།",
    accuracy: "正确率།",
    collected: "དེ་བསྡུ་ཉར།",
    entranceExamination: "སྒོ་རྒྱུགས་ལེན།",
    numberOfErrors: "ནོར་འཁྲུལ་ཐེངས་མང།",
    totalQuestionBank: "题库བསྡོམས་འབོར།",
    mockTest: "ལད་མོ་རྒྱུགས་ལེན།",
    registrationExamination: "རྒྱུགས་མིང་ཐོ་འགོད་པ།",
    submitAnswers: "ཕུལ་བའི་ལན།",
    registrationClosed: "རྒྱུགས་མིང་ཐོ་འགོད་པ་དེ་སྤྱི་ལོ།",
    rankingList: "排行榜།",
    startPracticing: "ཐོག་མར་གཤར་སྦྱང།",
    theExamCancelled: "ཐེངས་འདི་འི་རྒྱུགས་ལེན་དེ་མེད་པར་བཟོ།",
    fullScore: "满分།",
    theExamOver: "ཐེངས་འདི་འི་རྒྱུགས་ལེན་དེ་མཇུག་འགྲིལ།",
    totalTopic: "ཁ་བྱང་བསྡོམས་འབོར།",
    wrongQuestionBank: "ནོར་题库།",
    cantToRegister: "ཞིབ་བཤེར་གཏན་འབེབས་མ་བྱས་པར་བརྟེན་ནས་ཐབས་མེད་པར་མུ་མཐུ",
    viewResolution: "ལྟ་ཞིབ་དབྱེ་ཞིབ།",
    examPaperCannotOpene: "རྒྱུགས་དཔྱད་ཀྱི་ཁྲོད་ཀྱི་སྒོ་མོ་འབྱེད་པའི་རྒྱུགས་ཤོག།",
    slidingNextQuestion: "ཡས་མས་འདྲེད་འགུལ་ཡང་切换ནས་སྟེང་གི་གནད་དོན་དང་གནད་དོན།",
    yourScore: "ཁྱེད་ཀྱི་ཐོབ་སྐར།",
    keepPracticing: "མུ་མཐུད་གཤར་སྦྱང།",
    removeWrongQuestions: "སྤོས་རྣམས་ནོར་བ་འབྲི།",
    setOfExercises: "ཤུབས་གཤར་སྦྱང།",
    collection: "བསྡུ་ཉར།",
    practiceBeforeExam: "རྒྱུགས་གོང་གཤར་སྦྱང།",
    questionBankExercises: "题库གཤར་སྦྱང།",
    allHave: "ཁྱོན།",
    removed: "དེ་སྤོ་བྱ་དགོས་པ།",
    numberOfReExam: "སླར་ཟུར་རྒྱུགས་ལེན་པའི་ཐེངས་གྲངས།",
    cancelRegistration: "ཕྱིར་འཐེན་བྱ་རྒྱུ་འི་ཐོ་འགོད།",
    questionBank: "题库།",
    wrongQuestionSet: "ནོར་འདྲི་གཞི་ཚོགས།",
    practiced: "སྔར་ཡོད་ཀྱི་གཤར་སྦྱང།"
  },
  chat: {
    privateMessageTips: "ཁྱེད་ཀྱི་ཚད་私信ནང་དོན།",
    privateMsgEmptyTips: "私信ནང་དོན་དེ་སྟོང།",
    privateMsgDeletedSuccessfully: "私信སུབ་པ་ལེགས་གྲུབ།",
    privateMsgDeleteTips: "ཁྱེད་ཀྱིས་གཏན་ཁེལ་སུབ་པ་དེའི་私信གན།",
    privateLetter: "私信།",
    nowYouCanStartChatting: "ད་ལྟ་ནས་བཟུང་ལྷུག་པོར་了།"
  },
  course: {
    lastTime: "ཐེངས་སྔོན་མ་འགོར་འགྱངས་བྱས་པ།",
    courseIntroduction: "སློབ་ཚན་ངོ་སྤྲོད་མདོར་བསྡུས།",
    rightAnswer: "ལན་ཡང་དག་པ།",
    courseType: "སློབ་ཚན་རིགས་འབྱེད་པ་འི།",
    PracticeInClass: "ལྷན་ཕེབས་སློབ་ཚན་གཤར་སྦྱང།",
    answerOk: "ལན་ཡང་དག་པ།",
    examNotice: "རྒྱུགས་ལེན་དགོས།",
    data: "དཔྱད་ཡིག།",
    examInfo: "རྒྱུགས་ལེན་ཞིབ་ཆ།",
    aubutCourse: "འབྲེལ་ཡོད་སློབ་ཚན།",
    last5MinNotice: "བར་ཐག་རྒྱུགས་ཡིག་སྤྲོད་པའི་དུས་ཚོད་མཇུག་སྒྲིལ་ལ་ད་དུང་ན་སྐར་མ་5དུས་ཚོད་ཡོད་ཚད་འདོན་པ་རྗེས་མ་ལག་སྲིད་རང་འགུལ་རྒྱུགས་ཡིག་སྤྲོད་པ།དུས་ཚོད་དམ་འཛིན་བློ་ཡིད་འཚིམས་པ་འི།",
    bag: "དཔེ་ཁུག།",
    ExamInClass: "ལྷན་ཕེབས་སློབ་ཚན་རྒྱུགས།",
    thematicEvaluation: "ཆེད་དོན་གདེང་འཇོག།",
    elective: "བདམས་སྦྱོང།",
    chapterDownloaded: "ལེའུ་ཟིན་པ་ཁ་",
    me: "ང།",
    changeIt: "བརྗེ་གཅིག་བརྗེ།",
    courseInfo: "སློབ་ཚན་ཞིབ་ཆ།",
    evaluated: "ཁྱེད་ཀྱིས་ཟིན་པའི་གདེང་འཇོག་མྱོང་དེའི་སློབ་ཚན།",
    newest: "ཆེས་གསར་བ་འི།",
    questionList: "ཁ་བྱང་རེའུ་མིག་བཀོད།",
    takeNotes: "ཟིན་བྲིས་འབྲི་བ།",
    info: "ཞིབ་ཆ།",
    pausePlay: "མཚམས་འཇོག་རྒྱུའི་བསྟན་པ།",
    startPlay: "ཐོག་མར་བསྟན་པ།",
    inputNoteContent: "ཁྱེད་ཀྱི་ཚད་ཟིན་ཐོ་ནང་དོན།",
    onlineCourses: "དེ་ན་སློབ་ཚན།",
    nowCmpletion: "མིག་སྔར་ལེགས་གྲུབ།",
    exam: "རྒྱུགས་ལེན།",
    enableLogFunction: "ཕྱེ་བའི་ཉིན་ཐོ་ནུས་པ།",
    handInPapers: "རྒྱུགས་ཡིག་སྤྲོད་པ།",
    courseDetails: "སློབ་ཚན་ཞིབ་ཆ།",
    answerErr: "ལན་ནོར་འཁྲུལ།",
    myNotice: "ང་འི་ཟིན་ཐོ།",
    referenceAnswer: "དཔྱད་གཞི་འི་དྲིས་ལན།",
    courseLecturer: "སློབ་ཚན་འཆད་འཁྲིད་དགེ་རྒན།",
    editFail: "编辑失败",
    note: "ཟིན་བྲིས།",
    questionTips2: "མཆན།ལྗང་མདོག་ཡང་དག་པ་ཁ་བྱང་དམར་པོ་དེ་ནོར་འཁྲུལ་གྱི་ཁ་བྱང་དེ་མཚུངས་ཀྱི་འདྲི་གཞི་ཨང་ར་སླེབས་པའི་ཁ་བྱང།",
    private: "སྒེར་དབང།",
    notEnoughTimeTips: "མེད་ཀྱི་བླང་བྱ་སློབ་སྦྱོང་དུས་རིང་པོ།ཐབས་མེད་པར་གདེང་འཇོག།",
    isRecordedHour: "ཡིན་མིན་ཟིན་ཐོ་སློབ་ཁྲིད་དུས་ཡུན།",
    questionTips1: "མཆན།ལྗང་མདོག་གིས་ཟིན་པའི་དྲིས་ལན་ཁ་བྱང་དེ་མཚུངས་ཀྱི་འདྲི་གཞི་ཨང་ར་སླེབས་པའི་ཁ་བྱང།",
    handInPapersNotice: "རྒྱུགས་ཡིག་སྤྲོད་པའི་དྲན་སྐུལ།",
    courseDownload: "སློབ་ཚན་ཁ་",
    recommendedCourses: "འོས་སྦྱོར་སློབ་ཚན།",
    keepLearning: "མུ་མཐུད་སློབ་སྦྱོང།",
    yourAnswer: "ཁྱོད་ཀྱི་ལན།",
    playOver: "བསྟན་པ་མཇུག་རྫོགས།",
    openClass: "公开课།",
    manLearning: "སློབ་སྦྱོང།",
    allCourses: "ཡོངས་རྫོགས་སློབ་ཚན།",
    specialTraining: "ཆེད་དོན་གསོ་སྦྱོང།",
    hottest: "ཆེས་དྲོ་བ།",
    chapterSwitching: "ལེའུ་切换།",
    publick: "ཡོངས་བསྒྲགས།",
    CourseType: "སློབ་ཚན་གྱི་རིགས་དབྱིབས།",
    autoPlayNextVideo: "རང་འགུལ་གྱིས་བསྟན་པ་རྗེས་མའི་བརྙན་འཕྲིན།",
    selectCategory: "བསལ་འདེམས་ཀྱི་རིགས་དབྱེ།",
    noResourcesPlaying: "དགག་ལན་མུ་མཐུད་བསྟན་པའི་ཐོན་ཁུངས།",
    handInPapersConfirm: "ཁྱེད་ཀྱིས་གཏན་འཁེལ་རྒྱུགས་ཡིག་སྤྲོད་པ་དང་གན།",
    joinInLearning: "འཛམ་གླིང་སློབ་སྦྱོང།",
    exerciseResults: "སྦྱོང་བརྡར་བྱས་པའི་འབྲས་བུ།",
    surplus: "ལྷག་མ།",
    practiceAgain: "བསྐྱར་དུ་གཤར་སྦྱང།",
    deleteConfirm: "ཁྱེད་ཀྱིས་གཏན་ཁེལ་སུབ་པ་གན།",
    handInPapersErrorNotice: "རྒྱུགས་ཡིག་སྤྲོད་པར་ཕམ་ཁ་ས་跳转ནས་འབྲས་བུ་འི་ཤོག་ངོས།",
    totalSpace: "སྤྱིའི་བར་སྣང།",
    editSuccess: "རྩོམ་སྒྲིག་ལེགས་གྲུབ།",
    examNumber: "རྒྱུགས་ལེན་ཐེངས་གྲངས།",
    mobileNotSupported: "དེའི་ཐོན་ཁུངས་མི་བྱེད་པར་རྒྱབ་སྐྱོར་གནས་སྤོ་བསྟན་པ་བྱོས་ར་ཕེབས་ནས་pcལ་གཟིགས་ཞིབ།",
    compulsory: "ངེས་པར་སྦྱོང་དགོས་པ།",
    closeNotice: "རྒྱུགས་ཡིག་སྤྲོད་པ་རྗེས་ད་གཟོད་སླར་སྒོ་རྒྱག་མིག་སྔ་འི་ཤོག་ངོས།",
    specialTrainingCourses: "ཆེད་དོན་གསོ་སྦྱོང་གི་སློབ་ཚན།",
    noNotice: "གནས་སྐབས་མེད་པའི་ཤེས་རིག།",
    comprehensiveScore: "ཕྱོགས་བསྡུས་ཐོབ་སྐར།",
    HistoryFlowSend: "ལོ་རྒྱུས་ཀྱི་འབབ་ཆུ་འབུལ།",
    selectDownloadChapter: "སྔོན་ལ་འདེམས་下载ལེའུ་དང་།"
  },
  survey: {
    afterSchool: "སྦྱངས་རྗེས།",
    questionnaireDetails: "དྲི་ཤོག་ཞིབ་ཆ།"
  },
  information: {
    leaveAMessage: "བྲིས་མཐོང་སྣང་འབྲི་བ།",
    inputTheMessageContent: "ཁྱེད་ཀྱི་ཚད་མཐོང་སྣང་འབྲི་བའི་ནང་དོན།",
    leavingAMessage: "མཐོང་སྣང་འབྲི་བ།"
  },
  user: {
    displayName: 'མངོན་པའི་མིང།',
    nickname: "གླེང་གཞི།",
    userName: 'སྤྱོད་མཁན་མིང་།',
    systemNotification: 'མ་ལག་གི་བརྡ་ཐོ།',
    teacherRecommendation: 'དགེ་རྒན་གྱི་འོས་སྦྱོར།',
    learningArchives: 'སློབ་སྦྱོང་གི་ཡིག་ཚགས།',
    faceToFaceLearning: 'གདོང་འཕྲདསློབ་སྦྱོང།',
    onlineLearning: 'ནི་ཐིག་སློབ་སྦྱོང།',
    currentClass: "མིག་སྔ་འི་འཛིན་གྲྭ།",
    unbound: "མ་མགོ་སྦྲེལ།",
    administration: "དོ་དམ།",
    youAreIn: "ཁྱེད་ཀྱིས།",
    learningReminders: "དོན་ཚན་སློབ་སྦྱོང་བྱེད་པར་དྲན་སྐུལ།",
    binding: "བཞིན་མགོ་སྦྲེལ།",
    onlineClassHours: "དེ་ན་སློབ་ཁྲིད་དུས་ཡུན།",
    exceeds_10mPleaseReSelect: "ཡར་འཁོརམགོ་བརྙན་ཡིག་ཆ་ལས་བརྒལ་10M།ཁྱེད་ལ་བསྐྱར་དུ་འདེམས།",
    optionStatistics: "选项བསྡོམས་རྩིས།",
    myMessage: "ང་འི་གནས་ཚུལ།",
    exceeds_2mPleaseReSelect: "ཡར་འཁོརམགོ་བརྙན་ཡིག་ཆ་ལས་བརྒལ་2M།ཁྱེད་ལ་བསྐྱར་དུ་འདེམས།",
    accountSecurity: "རྩིས་ཐོའི་ཨང་གྲངས་བདེ་འཇགས།",
    assessment: "དཔྱད་དཔོག།",
    unbindWechat: "སེལ་བཀྱིགས་ཐོག་རྣམ།",
    post: "གོ་གནས།",
    exercises: "བསྐྱར་སྦྱོང་འདྲི་གཞི།",
    inputickname: "ཁྱེད་ཀྱི་ཚད་གླེང་གཞི།",
    loginName: "登录མིང།",
    myQuestionnaire: "ང་འི་དྲི་ཤོག།",
    rank: "འགན་རིམ།",
    questionnaireResults: "དྲི་ཤོག་གི་འབྲས་བུ།",
    female: "བུད་མེད།",
    cancelPhotoTaking: "མེད་པར་བཟོས་ནས་པར་རྒྱག།",
    cancelAuthorization: "ཕྱིར་འཐེན་བྱ་རྒྱུ་འི་དབང་ཆ།",
    cancelCollection: "ཕྱིར་འཐེན་བསྡུ་ཉར།",
    editingMaterials: "རྩོམ་སྒྲིག་བྱས་པའི་དཔྱད་ཡིག།",
    noGrouping: "གནས་སྐབས་མེད་པའི་ཚོགས་ཆུང་ཁག་བགོས་ཀྱི།",
    myCollection: "ང་བསྡུ་ཉར།",
    onlineCourses: "ཐིག་སྟེང་གི་སློབ་ཚན།",
    failedAuthentication: "ལག་སོན་登录ཁས་ལེན་བྱས་པའི་ཕམ་ཁ།",
    pleaseEnter: "ཁྱེད་ཀྱི་ཚད།",
    phoneNumber: "ཁ་པར་ཨང་གྲངས།",
    myLeave: "ང་འི་དུས་ཚོད།",
    reset: "བསྐྱར་གཅོད།",
    historyClass: "ལོ་རྒྱུས་ཀྱི་འཛིན་གྲྭ།",
    pleaseWaitNotice: "ཞིབ་ཕྲ་འི་དུས་ཚོད་རོགས་སྒུག་པའི་མ་ལག་གི་བརྡ་ཐོ།",
    male: "ཕོ།",
    private: "སྒེར་གྱི་གསང་སྔགས།",
    gender: "ཕོ་མོ།",
    selectPhotos: "བསལ་འདེམས་ཀྱི་འདྲ་པར།",
    selectFromPhone: "ནས་ཁ་པར་འདྲ་པར་ཉར་དེབ་བསལ་འདེམས།",
    bindingFailed: "མགོ་སྦྲེལཕམ་ཁ།",
    myClass: "ང་འི་འཛིན་གྲྭ།",
    idNumber: "ཐོབ་ཐང་ལག་ཁྱེར་ཨང།",
    cycle: "དུས་འཁོར།",
    conversations: "ཤིག་ལྒིང་མོལ།",
    areYouSure: "ཁྱེད་ཀྱིས་ཁས་ལེན་བྱེད་ཕྱིར་འཐེན་མགོ་སྦྲེལ།",
    theInputIsEmpty: "ནང་འདྲེན་ནང་དོན་སྟོང་པ།",
    unbinding: "བཞིན་ཕྱིར་འཐེན་མགོ་སྦྲེལ།",
    myDownloads: "ང་ཁ་",
    assessmentDetails: "དཔྱད་ཞིབ་གསལ།",
    email: "ཡིག་སྒམ།",
    classSurveyResults: "འཛིན་གྲྭ་འི་བརྟག་དཔྱད་བྱས་འབྲས།",
    assessmentResults: "དཔྱད་དཔོག་བྱས་འབྲས།",
    evaluationResults: "གདེང་འཇོག་བྱས་པའི་འབྲས་བུ།",
    pleaseSelectACourse: "ཁྱེད་ཀྱི་བསལ་འདེམས་ཀྱི་སློབ་ཚན་འམ་ཐོན་ཁུངས་སླར་ཡང་སུ",
    bound: "དེ་མགོ་སྦྲེལ།",
    fullName: "རུས་མིང།",
    totalSpace: "སྤྱིའི་བར་སྣང།",
    curriculum: "སློབ་ཚན།",
    onPcOrApp: "ཁྱོ་ས་pcརྒྱལ་བོ་འམ་appབརྗེ་མགོ་བརྙན།",
    photograph: "པར་རྒྱག།",
    cellPhoneNumber: "ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས།",
    myNotes: "ང་འི་ཟིན་ཐོ།",
    faceToFaceHours: "གདོང་འཕྲདསློབ་ཁྲིད་དུས་ཡུན།",
    to: "ནས།",
    complete: "ལེགས་གྲུབ།",
    editPersonalInformation: "རྩོམ་སྒྲིག་པ་དང་མི་སྒེར་གྱི་ཆ་འཕྲིན།",
    downloadCompleted: "ལེགས་གྲུབ་ཟིན་པ་དང་ཁ་"
  }
}
